import React, { useEffect, useState } from "react";
import '../../stylesheets/Dashboard.css'
import '../../stylesheets/Main.css'
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';
import { DashboardAPI } from "../../axios";

const Dashboard = () => {
  const [usersCount, setUsersCount] = useState(0);
  const [wastesCount, setWastesCount] = useState(0);

  useEffect(() => {
    DashboardAPI.homepage()
      .then((res) => {
        if (res.code === 200) {
          setUsersCount(res.data.usersCount);
          setWastesCount(res.data.wastesCount);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="main-container">
      <Toolbar />
      <Sidebar />
      <div className="content-container">
        <div className="main-content">
          <h3> Dashboard </h3>
          <div className="cards">
            <div className="card">
              <span className="card-title"> Total Users </span>
              <span className="card-count"> {usersCount} </span>
            </div>
            <div className="card">
              <span className="card-title"> Total Engagement </span>
              <span className="card-count"> 900 </span>
            </div>
            <div className="card">
              <span className="card-title"> Total Reports </span>
              <span className="card-count"> {wastesCount} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
